module.exports = __webpack_public_path__ + "assets/img/zhejiang.1288a85b.png";